<div
  [class]="
    direction() === 'vertical'
      ? 'space-y-2 flex flex-col'
      : 'flex flex-row space-x-1 items-center'
  "
  [class.justify-between]="distributeWidthMode() === 'between'">
  <span class="font-light text-sm text-text">
    {{ label() }}
  </span>
  <div [class]="containerClasses()">
    @for (option of options(); track option.value) {
      <label class="relative flex items-center cursor-pointer">
        <input
          type="radio"
          [name]="label()"
          [value]="option.value"
          [checked]="value === option.value"
          [disabled]="isDisabled"
          [class.opacity-50]="isDisabled"
          [class.cursor-not-allowed]="isDisabled"
          (change)="onValueChange(option.value)"
          class="peer h-5 w-5 cursor-pointer appearance-none rounded-full border-2 border-text checked:border-primary-700 transition-all" />
        <span
          class="absolute bg-primary-700 w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
      </label>
      <label
        for="radio-{{ option.value }}"
        class="flex items-center gap-1 cursor-pointer">
        {{ option.label }}
      </label>
    }
  </div>
</div>
